// extracted by mini-css-extract-plugin
export default {"label":"notification-content_label__4BZ5+","time":"notification-content_time__edsT+"};